import type { AnyAction, Middleware } from 'redux';
import { createAudioConnection } from '../../../services/WsConnection';
import { proto, types } from '../../../proto/ListenerProto';
import { daemonInitialized, types as mainTypes } from '../../actions/backendMain';
import {
    types as deviceTypes,
    audioChunkReceived,
    deviceConnectionClosed,
    deviceConnectionOpened,
    recordingInfoReceived
} from '../../actions/backendDevice';
import { reload } from '../../actions/backendCommon';
import { errorCodes } from '../../../utils/utils';
import { deviceLogger } from '../../../utils/logger/loggerFactory';
import { dispatchBackend } from '../../types/backend';

const { AUDIO_DEVICE_STOPPED } = errorCodes.background;

const audioDeviceConnections: Middleware = store => {
    function createAudioDeviceConnection({ port }: { port: number }) {
        const ws = createAudioConnection({ host: 'localhost', port });
        ws.on('opened', () => {
            dispatchBackend(store.dispatch, deviceConnectionOpened(port));
        });
        ws.on('closed', ({ wasClean }) => {
            dispatchBackend(store.dispatch, deviceConnectionClosed({ wasClean }));
        });
        ws.on('message', (data: Uint8Array) => {
            const { audioResponseType, recordingInfo, audioChunk } = proto.AudioResponse.decode(data);

            if (audioResponseType === types.RECORDING_INFO) {
                deviceLogger.log('recordingInfo:', recordingInfo);
                dispatchBackend(store.dispatch, recordingInfoReceived(recordingInfo));
            } else if (audioResponseType === types.AUDIO_CHUNK) {
                const {
                    audio,
                    offsetInAudioStreamMsec,
                    dataFlow //  DataFlow.CAPTURE=1,DataFlow.RENDER=2
                } = audioChunk;

                dispatchBackend(
                    store.dispatch,
                    audioChunkReceived({
                        audio,
                        offsetInAudioStreamMsec,
                        channel: dataFlow
                    })
                );
            }
        });

        return ws;
    }

    return next => action => {
        const typedAction = action as AnyAction;
        const { type, payload } = typedAction;
        const result = next(action);

        switch (type) {
            case mainTypes.START_AUDIO_DEVICE_CONNECTION: {
                createAudioDeviceConnection(payload);
                break;
            }
            case deviceTypes.DEVICE_CONNECTION_CLOSED: {
                if (!payload.wasClean) {
                    dispatchBackend(
                        store.dispatch,
                        reload({
                            code: AUDIO_DEVICE_STOPPED,
                            reason: 'AUDIO_DEVICE_STOPPED'
                        })
                    );
                }
                break;
            }
            case deviceTypes.DEVICE_CONNECTION_OPENED: {
                dispatchBackend(store.dispatch, daemonInitialized());
                break;
            }
            default:
        }

        return result;
    };
};

export default audioDeviceConnections;
